module.exports = __webpack_public_path__ + "38235b952050514e48cd20c35354f5ae.jpg";